<template lang="pug">
el-dialog.dialog-edit-properties(:visible.sync='visible', size='large', :before-close='exit')
  .ui.grid.two.columns.stackable
    .column
      h3 房间物品
      auto-table(:defines='$defines.property', unstackable, :data='room_properties', layout='editing',
        actions='add minus remove', :pagesize='15',
        @action:add='item_add', @action:minus='item_minus', @action:remove='removeProp')
    .column
      h3 库存物品
      auto-table(:defines='$defines.property', unstackable, :data='all_properties',
        left-actions='moveleft', :pagesize='15',
        @action:moveleft='moveleft')

  .ui.field.actions
    .ui.button.themed(@click='save') 确定
    .ui.button(@click='reset') 重置
    .ui.button(@click='exit') 取消
</template>

<script>
import { AutoTable } from '../auto'

export default {
  name: 'dialog-edit-properties',
  props: ['no', 'properties', 'indialog', 'visible'],
  components: { AutoTable },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    all_properties() {
      return this.$store.getters.properties
    },
    room_properties() {
      return this.form.properties.map((prop) => Object.assign(
        {
          get note() { return prop.note },
          set note(value) {
            if (value != null)
              prop.note = value
          },
          get variant() { return prop.variant },
          set variant(value) { prop.variant = value },
        },
        this.$store.getters.property(prop._id), {
          get note() { return prop.note },
          quantity: prop.quantity,
        }))
    },
  },
  data() {
    return {
      form: {
        properties: [],
      },
    }
  },
  mounted() {
    this.init()
  },
  watch: {
    visible() {
      this.init()
    },
    properties() {
      this.init()
    },
  },
  methods: {
    init() {
      this.form.properties = JSON.parse(JSON.stringify(this.properties || this.room.properties || []))
    },
    exit() {
      this.$emit('update:visible', false)
      this.$emit('exit')
    },
    reset() {
      this.init()
    },
    save() {
      this.$emit('update:properties', this.form.properties)
      this.exit()
    },
    item_add(record) {
      const variant = (record.variant || [])[0]
      const prop = this.form.properties.filter(p => p._id === record._id && p.variant === variant)[0]
      if (prop)
        prop.quantity = (prop.quantity || 0) + 1
    },
    item_minus(record) {
      this.moveright(record)
    },
    moveleft(record) {
      const variant = (record.variants || [])[0]
      const prop = this.form.properties.filter(p => p._id === record._id && p.variant === variant)[0]
      if (prop)
        prop.quantity = (prop.quantity || 0) + 1
      else
        this.form.properties.push({ _id: record._id, quantity: 1, variant })
    },
    moveright(record) {
      const prop = this.form.properties.filter(p => p._id === record._id)[0]
      if (prop)
        prop.quantity = (prop.quantity || 0) - 1
      if (!prop.quantity) {
        const index = this.form.properties.indexOf(prop)
        if (index > -1)
          this.form.properties.splice(index, 1)
      }
    },
    removeProp(record) {
      const prop = this.form.properties.filter(p => p._id === record._id)[0]
      if (prop) {
        const index = this.form.properties.indexOf(prop)
        if (index > -1)
          this.form.properties.splice(index, 1)
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// DialogEditProperties.vue?102eb193